var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cursor",staticClass:"timeline-cursor",class:( _obj = {}, _obj[_vm.color] = true, _obj['d-none'] =  _vm.hidden, _obj ),style:({
    left: ((_vm.position * 100) + "%"),
    'transition-duration': (_vm.motionDuration + "s")
  })})}
var staticRenderFns = []

export { render, staticRenderFns }